import { faqs, stats } from './content'
import type { FaqItem, Stat } from './content'
import { offer } from './content'

export const kitHero = {
  subheadline: '5 volumi + 5 bonus pronti da usare',
  description:
    "44 idee, 33 giochi con messaggio, 25 incontri pronti, 28 sfide, 100 versetti e il laboratorio dell'animatore. Tutto spiegato passo dopo passo: meno improvvisazione, più incontri in cui i ragazzi hanno voglia di tornare.",
}

export const kitStats: Stat[] = stats

export interface Kit {
  number: string
  title: string
  hook: string
  description: string
}

export const kitsCopy = {
  title: 'E non finisce qui: ricevi anche 5 bonus.',
  subtitle:
    "Materiali pronti che ti semplificano la vita per tutto l'anno: dall'invito all'incontro al ricordino di fine ritiro.",
  badge: 'Incluso',
  closing:
    'Dalla prima locandina alla lettera per il mese più difficile: cinque strumenti per guidare il gruppo con più serenità e più gioia.',
  closingNote: 'Tutti e 5 i bonus sono nel kit completo.',
}

export const kits: Kit[] = [
  {
    number: '01',
    title: 'Sfida dei 21 giorni "Riaccendi la fede"',
    hook: 'Tre settimane per riaccendere la fede del tuo gruppo.',
    description:
      '21 giorni con un brano della Bibbia, una riflessione, una piccola sfida, una domanda e una preghiera. Ogni giorno, un messaggio già pronto da incollare sul gruppo WhatsApp.',
  },
  {
    number: '02',
    title: 'Percorso Dopocresima: 8 incontri per non perderli',
    hook: 'Dopo la Cresima spariscono? Comincia da qui.',
    description:
      '8 incontri pronti per i ragazzi appena cresimati, con giochi, Parola, domande e preghiera. In più: come invitarli uno per uno e cosa fare se ne arrivano solo tre.',
  },
  {
    number: '03',
    title: 'Locandine, inviti e ricordini da stampare',
    hook: 'Invitali in modo che abbiano voglia di venire.',
    description:
      '24 locandine e inviti per incontri, adorazione, ritiri e campi, messaggi per WhatsApp e avvisi da leggere a Messa. In più, 40 segnalibri e 30 bigliettini.',
  },
  {
    number: '04',
    title: 'I 4 Vangeli in gioco: quiz e schede',
    hook: 'Scoprite i Vangeli insieme, con curiosità.',
    description:
      'Per ogni Vangelo: i brani più importanti, una scheda per un incontro biblico e un quiz. Alla fine, il grande quiz a squadre.',
  },
  {
    number: '05',
    title: "12 lettere all'animatore",
    hook: 'Perché anche chi guida ha bisogno di sostegno.',
    description:
      "Una lettera per ogni mese dell'anno pastorale, con la Parola, domande per riflettere e una preghiera: per la stanchezza, i discorsi difficili e quando si riparte.",
  },
]

export interface KitOfferRow {
  title: string
  detail: string
}

export const kitOffer = {
  label: 'Il kit completo per chi guida un gruppo giovani',
  name: "Il Kit dell'Animatore",
  summary: '5 volumi + 5 bonus',
  status: 'Incluso',
  bundle: 'Oltre 300 materiali pronti',
  bundleNote: 'Tutto in ordine. Un solo acquisto. Nessun abbonamento.',
  priceLabel: 'Tutto il kit a soli',
  price: offer.price,
  currency: offer.currency,
  priceNote: 'Pagamento unico. Accesso per sempre.',
  cta: 'Sì, voglio il kit completo',
  note: 'Pagamento sicuro · Accesso immediato · Garanzia di 7 giorni',
  closing: "Costa meno di una pizzata con il gruppo, e ti basta per tutto l'anno.",
}

export const kitOfferRows: KitOfferRow[] = [
  {
    title: 'Volume 1 e Volume 2',
    detail: '44 idee per incontri e ritiri + 33 giochi e dinamiche con messaggio.',
  },
  {
    title: 'Volume 3 e Volume 4',
    detail: '25 incontri pronti + 28 sfide settimanali e 100 versetti con riflessione.',
  },
  {
    title: "Volume 5 · Il laboratorio dell'animatore",
    detail: "20 strategie, come preparare un incontro, ritiri e campi passo dopo passo e la mappa dell'anno pastorale.",
  },
  {
    title: '5 bonus',
    detail: "Sfida dei 21 giorni, Percorso Dopocresima, locandine e ricordini, quiz sui Vangeli e lettere all'animatore.",
  },
  {
    title: 'Accesso digitale completo',
    detail: 'PDF da stampare e da aprire sul telefono · Accesso immediato · Per sempre.',
  },
]

export const kitFinalCta = {
  title: 'Oltre 300 materiali pronti. I tuoi incontri sono già fatti.',
  subtitle:
    "Idee, giochi, incontri, sfide, preghiere e il laboratorio dell'animatore in un solo kit. Scegli. Stampa. Guida.",
  summary: '5 volumi + 5 bonus',
  cta: 'Voglio il kit completo',
}

export const kitFaqs: FaqItem[] = faqs
